/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Clear_All_ButtonInputs */

const en_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear All`)
};

const fr_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout effacer`)
};

const de_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles löschen`)
};

const it_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella tutto`)
};

const ru_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить все`)
};

const es_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todo`)
};

const zh_cn2_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部清除`)
};

const ja_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてクリア`)
};

const hi_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी साफ करें`)
};

const pt_pt2_segment_event_group_clear_all_button = /** @type {(inputs: Segment_Event_Group_Clear_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar tudo`)
};

/**
* | output |
* | --- |
* | "Clear All" |
*
* @param {Segment_Event_Group_Clear_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_clear_all_button = /** @type {((inputs?: Segment_Event_Group_Clear_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Clear_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_clear_all_button(inputs)
	if (locale === "de") return de_segment_event_group_clear_all_button(inputs)
	if (locale === "it") return it_segment_event_group_clear_all_button(inputs)
	if (locale === "ru") return ru_segment_event_group_clear_all_button(inputs)
	if (locale === "es") return es_segment_event_group_clear_all_button(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_clear_all_button(inputs)
	if (locale === "ja") return ja_segment_event_group_clear_all_button(inputs)
	if (locale === "hi") return hi_segment_event_group_clear_all_button(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_clear_all_button(inputs)
	return en_segment_event_group_clear_all_button(inputs)
});